var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage, setSuccessMessage } from '@popup/multichain/actions/message.actions';
import { navigateToWithParams } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { addAccount } from '@popup/steem/actions/account.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { Screen } from 'src/reference-data/screen.enum';
const AddByKeys = ({ navigateToWithParams, localAccounts, addAccount, setTitleContainerProperties, setErrorMessage, setSuccessMessage, }) => {
    const [username, setUsername] = useState('');
    const [privateKey, setPrivateKey] = useState('');
    const [privateHiveKey, setHivePrivateKey] = useState('');
    const [privateBlurtKey, setBlurtPrivateKey] = useState('');
    const [copyToHive, setCopyToHive] = useState(false);
    const [copyToBlurt, setCopyToBlurt] = useState(false);
    const [isProcessingFile, setIsProcessingFile] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showImportResult, setShowImportResult] = useState(false);
    const [importResult, setImportResult] = useState(null);
    const [importProgress, setImportProgress] = useState('');
    // Copia automatica chiavi
    useEffect(() => {
        if (copyToHive) {
            setHivePrivateKey(privateKey);
        }
    }, [privateKey, copyToHive]);
    useEffect(() => {
        if (copyToBlurt) {
            setBlurtPrivateKey(privateKey);
        }
    }, [privateKey, copyToBlurt]);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_setup',
            isBackButtonEnabled: true,
            isCloseButtonDisabled: localAccounts.length === 0,
        });
    }, [localAccounts.length, setTitleContainerProperties]);
    // ====================== IMPORT MASSIVO DA FILE ======================
    const handleFileImport = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        setImportProgress('Importing from file...');
        setIsProcessingFile(true);
        let successCount = 0;
        let alreadyExistsCount = 0;
        let errorCount = 0;
        let loadedList = [];
        let alreadyList = [];
        let errorList = [];
        const accountsToAdd = [];
        try {
            const text = yield file.text();
            const lines = text
                .split('\n')
                .map(line => line.trim())
                .filter(line => line && !line.startsWith('#'));
            const totalLines = lines.length;
            //	  for (const line of lines) {
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                setImportProgress(`Importing line ${i + 1}/${totalLines}...`);
                const [user, steemKey, hiveKey, blurtKey] = line.split(',').map(s => s.trim());
                if (!user)
                    continue;
                // Controllo se l'utente esiste già
                if (localAccounts.map((acc) => acc.name).includes(user)) {
                    alreadyExistsCount++;
                    alreadyList.push(user);
                    continue;
                }
                let keys;
                try {
                    keys = yield AccountUtils.verifyAccount(user, steemKey || '', hiveKey || '', blurtKey || '', localAccounts);
                }
                catch (err) {
                    errorCount++;
                    errorList.push(user);
                    continue;
                }
                if (keys) {
                    accountsToAdd.push({ name: user, keys });
                    loadedList.push(user);
                    successCount++;
                    continue;
                }
            }
            // Messaggio finale intelligente
            setImportResult({
                successCount,
                alreadyExistsCount,
                errorCount,
                loadedList,
                alreadyList,
                errorList,
                total: lines.length,
                accountsToAdd
            });
            setShowImportResult(true);
        }
        catch (err) {
            setErrorMessage('Error loading file: ' + err.message);
        }
        finally {
            setIsProcessingFile(false);
            setImportProgress('');
            event.target.value = '';
        }
    });
    // Chiamata quando l'utente preme OK sul popup
    const confirmImport = () => {
        var _a;
        if (((_a = importResult === null || importResult === void 0 ? void 0 : importResult.accountsToAdd) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            importResult.accountsToAdd.forEach(({ name, keys }) => {
                addAccount({ name, keys });
            });
        }
        setShowImportResult(false);
        setImportResult(null);
    };
    // ====================== SUBMIT SINGOLO ======================
    const submitForm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isProcessingFile)
            return;
        // L'import massivo è gestito dal file input
        setIsSubmitting(true);
        // Codice originale per singolo account
        if (localAccounts.map((acc) => acc.name).includes(username)) {
            setErrorMessage('popup_html_account_already_existing');
            setIsSubmitting(false);
            return;
        }
        let keys;
        try {
            keys = yield AccountUtils.verifyAccount(username.trim(), privateKey.trim(), privateHiveKey.trim(), privateBlurtKey.trim(), localAccounts);
        }
        catch (err) {
            setErrorMessage(err.message);
            setIsSubmitting(false);
            return;
        }
        if (!keys)
            return;
        if (KeysUtils.keysCount(keys) > 2) {
            setIsSubmitting(false);
            navigateToWithParams(Screen.ACCOUNT_PAGE_SELECT_KEYS, { keys, username });
        }
        else {
            setIsSubmitting(false);
            addAccount({ name: username, keys });
        }
        setIsSubmitting(false);
    });
    return (React.createElement("div", { "data-testid": `${Screen.ACCOUNT_PAGE_ADD_BY_KEYS}-page`, className: "add-by-keys-page" },
        React.createElement("div", { className: "caption", dangerouslySetInnerHTML: { __html: getMessage('popup_html_setup_text') } }),
        React.createElement("div", { className: "form-container", style: { gap: '6px' } },
            React.createElement("label", { style: { display: 'block', marginBottom: '4px' } },
                React.createElement(ButtonComponent, { height: "small", label: isProcessingFile
                        ? (importProgress || 'Importing from file...')
                        : '📁 Import Accounts from File (CSV / TXT)', onClick: () => { var _a; return (_a = document.getElementById('mass-import-input')) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: isProcessingFile || isSubmitting }),
                React.createElement("input", { id: "mass-import-input", type: "file", accept: ".txt,.csv", style: { display: 'none' }, onChange: handleFileImport })),
            React.createElement(InputComponent, { dataTestId: "input-username", value: username, onChange: setUsername, logo: SVGIcons.INPUT_AT, label: "popup_html_username", placeholder: "popup_html_username", type: InputType.TEXT, onEnterPress: submitForm }),
            React.createElement(InputComponent, { dataTestId: "input-steem-key", value: privateKey, onChange: setPrivateKey, label: "popup_html_steem_private_key", placeholder: "popup_html_steem_private_key", type: InputType.PASSWORD, onEnterPress: submitForm }),
            React.createElement("div", { className: "input-with-checkbox" },
                React.createElement(InputComponent, { dataTestId: "input-hive-key", value: privateHiveKey, onChange: (value) => {
                        setHivePrivateKey(value);
                        if (value !== privateKey)
                            setCopyToHive(false);
                    }, label: "popup_html_hive_private_key", placeholder: "popup_html_hive_private_key", type: InputType.PASSWORD, onEnterPress: submitForm, disabled: copyToHive }),
                React.createElement("label", { className: "checkbox-label" },
                    React.createElement("input", { type: "checkbox", checked: copyToHive, onChange: (e) => {
                            const checked = e.target.checked;
                            setCopyToHive(checked);
                            if (checked)
                                setHivePrivateKey(privateKey);
                        } }),
                    getMessage('popup_html_use_steem_password'))),
            React.createElement("div", { className: "input-with-checkbox" },
                React.createElement(InputComponent, { dataTestId: "input-blurt-key", value: privateBlurtKey, onChange: (value) => {
                        setBlurtPrivateKey(value);
                        if (value !== privateKey)
                            setCopyToBlurt(false);
                    }, label: "popup_html_blurt_private_key", placeholder: "popup_html_blurt_private_key", type: InputType.PASSWORD, onEnterPress: submitForm, disabled: copyToBlurt }),
                React.createElement("label", { className: "checkbox-label" },
                    React.createElement("input", { type: "checkbox", checked: copyToBlurt, onChange: (e) => {
                            const checked = e.target.checked;
                            setCopyToBlurt(checked);
                            if (checked)
                                setBlurtPrivateKey(privateKey);
                        } }),
                    getMessage('popup_html_use_steem_password'))),
            React.createElement(ButtonComponent, { height: "small", dataTestId: "submit-button", label: isSubmitting ? 'Importing...' : 'popup_html_submit', onClick: submitForm, disabled: isProcessingFile || isSubmitting })),
        showImportResult && importResult && (React.createElement("div", { style: {
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.85)', zIndex: 10000,
                display: 'flex', alignItems: 'center', justifyContent: 'center'
            } },
            React.createElement("div", { style: {
                    background: '#161b22', color: '#e6edf3', padding: '24px',
                    borderRadius: '12px', maxWidth: '500px', width: '90%'
                } },
                React.createElement("h3", null, "Import Result"),
                React.createElement("p", null,
                    React.createElement("strong", null, "Total lines processed:"),
                    " ",
                    importResult.total),
                React.createElement("p", { style: { color: '#3fb950' } },
                    React.createElement("strong", null, "\u2705 New To Be loaded:"),
                    " ",
                    importResult.successCount),
                React.createElement("p", { style: { color: '#f0b849' } },
                    React.createElement("strong", null, "\u26A0\uFE0F Already present:"),
                    " ",
                    importResult.alreadyExistsCount),
                React.createElement("p", { style: { color: '#ff6b6b' } },
                    React.createElement("strong", null, "\u274C Errors:"),
                    " ",
                    importResult.errorCount),
                importResult.loadedList.length > 0 && (React.createElement("p", null,
                    React.createElement("strong", null, "New To Be Loaded:"),
                    " ",
                    importResult.loadedList.join(', '))),
                importResult.alreadyList.length > 0 && (React.createElement("p", null,
                    React.createElement("strong", null, "Already present:"),
                    " ",
                    importResult.alreadyList.join(', '))),
                importResult.errorList.length > 0 && (React.createElement("p", null,
                    React.createElement("strong", null, "Errors:"),
                    " ",
                    importResult.errorList.join(', '))),
                React.createElement(ButtonComponent, { label: "OK", onClick: confirmImport }))))));
};
const mapStateToProps = (state) => ({
    localAccounts: state.steem.accounts,
});
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    addAccount,
    setTitleContainerProperties,
    setErrorMessage,
    setSuccessMessage,
});
export const AddByKeysComponent = connector(AddByKeys);
